import { useOne } from "@refinedev/core";
import { useOrganization } from "hooks/useOrganization";
import { ContactResponse, PresenterProfileResponse } from "pages/media/types";
import { useMemo } from "react";

export const useExistingContact = (id?: string) => {
  const { organization } = useOrganization({});
  const contactEnabled = useMemo(
    () => !!id && !!organization?.id,
    [id, organization?.id]
  );

  const {
    data: contactData,
    isFetching,
    refetch,
    fetchStatus: fetchStatusContact,
  } = useOne<ContactResponse>({
    resource: `media/${organization?.id}/contacts`,
    id,
    queryOptions: {
      enabled: contactEnabled,
    },
  });

  const presenterEnabled =
    contactEnabled &&
    !!contactData?.data?.presenter_id &&
    !!organization?.id &&
    fetchStatusContact === "idle";

  const { data: presenterData, fetchStatus: fetchStatusPresenter } =
    useOne<PresenterProfileResponse>({
      resource: `media/${organization?.id}/presenter_profiles`,
      id: contactData?.data?.presenter_id,
      queryOptions: {
        keepPreviousData: false,
        enabled: presenterEnabled,
      },
    });
  const loading =
    fetchStatusContact !== "idle" || fetchStatusPresenter !== "idle";

  return {
    data: {
      contact: contactData,
      presenter: presenterData,
    },
    isFetching,
    isLoading: !!id && loading,
    refetch: async () => await refetch(),
  };
};
